import { useEffect, useMemo, useState } from 'react'

function useDarkMode() {
  const [isDark, setIsDark] = useState(() => document.documentElement.classList.contains('dark'))

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsDark(document.documentElement.classList.contains('dark'))
    })
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] })
    return () => observer.disconnect()
  }, [])

  return isDark
}

export function useChartTheme() {
  const isDark = useDarkMode()

  return useMemo(() => {
    const textColor = isDark ? '#e2e6e9' : '#1d2830'
    const mutedText = isDark ? '#9aa3ad' : '#656F78'
    const gridStroke = isDark ? 'rgba(226, 230, 233, 0.12)' : 'rgba(29, 40, 48, 0.1)'
    const axisStroke = isDark ? 'rgba(226, 230, 233, 0.25)' : 'rgba(29, 40, 48, 0.2)'
    const crosshairStroke = isDark ? '#656F78' : '#9aa3ad'

    return {
      isDark,
      textColor,
      mutedText,
      gridStroke,
      axisStroke,
      crosshairStroke,
      nivoTheme: {
        textColor,
        axis: {
          ticks: { text: { fill: mutedText } },
          legend: { text: { fill: mutedText } },
        },
        crosshair: {
          line: {
            stroke: crosshairStroke,
            strokeWidth: 1,
            strokeOpacity: 0.75,
            strokeDasharray: '6 6',
          },
        },
      },
    }
  }, [isDark])
}
